import { useState, useCallback } from "react";
import dayjs from "dayjs";

//  import { showError } from "../utils/showError"; // adjust path
import { API_ENDPOINTS } from "../../config/api/apiCall";

export const useInvoiceOrderList = (showError) => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadInvoiceOrderList = useCallback(async (FromDate, ToDate, searchType = "", searchValue = "") => {
    if (!FromDate) {
      showError("Please select the from date", "warning");
      return;
    }
    if (!ToDate) {
      showError("Please select the to date", "warning");
      return;
    }

    setLoading(true);

    const requestBody = {
      SearchType: searchType,        // 🔥 add searchType
        SearchString: searchValue,     // 🔥 add searchValue
      SInvoiceNo: "",
      InvoiceDateFrom: dayjs(FromDate).format("YYYY-MMM-DD"),
      InvoiceDateTo: dayjs(ToDate).format("YYYY-MMM-DD"),
      ConstructedGlobalValues: {
        COMPANY_FINANCIAL_YEAR_ID: 1,
        COMPANY_ID: localStorage.getItem("companyid"),
      },
    };

    try {
      const response = await fetch(API_ENDPOINTS.LoadInoviceOrderList, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "Unable to load invoice order details");
      }

      const data = await response.json();

      const formattedData = data.map((row, index) => {
       
        return { ...row, id: index + 1 };
      });

      setTableData(formattedData);
    } catch (error) {
      showError(`Error: ${error.message}`, "error");
      console.error("Error details:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  return { tableData, loading, loadInvoiceOrderList };
};
